import { Link, useNavigate } from "react-router-dom";
import { useState, useEffect } from "react";
import { Menu, X, Phone } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useCurrency } from "@/context/CurrencyContext";

const links = [
  { to: "/flights", label: "Flights" },
  { to: "/hotels", label: "Hotels" },
  { to: "/holidays", label: "Holidays" },
  { to: "/car-hire", label: "Car Hire" },
  { to: "/umrah", label: "Umrah" },
  { to: "/hajj", label: "Hajj 2026" },
  { to: "/manage-booking", label: "My Booking" },
];

export const Navbar = () => {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const { cur, setCur } = useCurrency();
  const nav = useNavigate();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header className={`sticky top-0 z-50 transition-colors duration-300 ${scrolled ? "bg-[#070B14]/95 backdrop-blur-xl border-b border-white/10 shadow-lg" : "bg-[#070B14]/55 backdrop-blur-md border-b border-white/5"}`}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 h-16 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-2" data-testid="logo-home-link">
          <img src="/logo-footer.png" alt="Elia Travel & Tours" className="h-9 w-auto object-contain" />
        </Link>

        <nav className="hidden lg:flex items-center gap-0.5">
          {links.map((l) => (
            <Link key={l.to} to={l.to} data-testid={`nav-${l.label.toLowerCase().replace(/[^a-z]/g, "-")}`}
              className={`px-3 py-2 rounded-full text-sm font-medium transition-colors ${l.to === "/flights" ? "text-[#FF6B35] hover:text-white" : "text-slate-200 hover:text-white hover:bg-white/10"}`}>
              {l.label}
            </Link>
          ))}
        </nav>

        <div className="hidden lg:flex items-center gap-3">
          <select value={cur} onChange={(e) => setCur(e.target.value)} data-testid="currency-select"
            className="bg-white/10 text-white text-sm rounded-full px-2.5 py-1.5 outline-none border border-white/15 cursor-pointer">
            <option className="text-slate-900" value="GBP">£ GBP</option>
            <option className="text-slate-900" value="USD">$ USD</option>
            <option className="text-slate-900" value="EUR">€ EUR</option>
          </select>
          <a href="tel:02046153141" className="flex items-center gap-2 text-sm font-semibold text-white">
            <Phone className="w-4 h-4 text-[#FF6B35]" /> 020 4615 3141
          </a>
          <Button onClick={() => nav("/contact")} data-testid="nav-enquire-btn"
            className="rounded-full bg-[#FF6B35] hover:bg-[#e85a26] text-white font-semibold">
            Enquire Now
          </Button>
        </div>

        <button className="lg:hidden p-2 text-white" onClick={() => setOpen(!open)} data-testid="mobile-menu-toggle">
          {open ? <X /> : <Menu />}
        </button>
      </div>

      {open && (
        <div className="lg:hidden border-t border-white/10 bg-[#070B14] px-4 py-3 space-y-1">
          {links.map((l) => (
            <Link key={l.to} to={l.to} onClick={() => setOpen(false)}
              className="block px-3 py-2 rounded-lg text-slate-200 hover:bg-white/10">{l.label}</Link>
          ))}
          <Button onClick={() => { setOpen(false); nav("/contact"); }}
            className="w-full rounded-full bg-[#FF6B35] hover:bg-[#e85a26] text-white mt-2">Enquire Now</Button>
        </div>
      )}
    </header>
  );
};
